import React from 'react';

import { Faq } from 'components/faq/Faq';

export const FaqPage: React.FC = () => <Faq />;
